<dsp-content-card [types]="[ 'select', 'select', 'select', 'datepicker', 'datepicker']">
  <atlas-field-select [style.--radius-xsmall]="'4px'" [widthValue]="270" [size]="sizeMedium" *dsp-content-filter
    [label]="'Select Your Option'" placeholder="Pick One" [multiselectable]="false" [options]="reportTypeOptions"
    [(ngModel)]="reportType.value" (valueChange)="onChangeFilter($event)" [clearable]="false">
  </atlas-field-select>
  <div dsp-content>
    <div class="row">
      <div class="columns">
        <div class="dsp-content-container mos-u-spacer--padding-md" style="padding-top: 5px !important;">
          <div class="dsp-reports-tabs" *ngIf="!showExcel">
            <div class="row">
              <div class="columns">
                <div class="dsp-date-row dsp-content-filters-row">
                  <div class=" dsp-filter year">
                    <atlas-field-select [style.--radius-xsmall]="'4px'" [widthValue]="270" [size]="sizeMedium"
                      [id]="'reports-year-filter'" [label]="'As At Year'" placeholder="Pick One"
                      [multiselectable]="false" [options]="yearFilterOptions$ | async"
                      [disabled]="!(years$ | async).length" [(ngModel)]="year" (valueChange)="onChangeYear($event)"
                      [clearable]="false">
                    </atlas-field-select>

                  </div>
                  <div class=" dsp-filter month">
                    <atlas-field-select [style.--radius-xsmall]="'4px'" [widthValue]="270" [size]="sizeMedium"
                      [id]="'reports-month-filter'" [label]="'As At Month'" placeholder="Pick One"
                      [multiselectable]="false" [options]="monthFilterOptions$ | async"
                      [disabled]="!(months$ | async).length" [(ngModel)]="month" (valueChange)="onChangeMonth($event)"
                      [clearable]="false">
                    </atlas-field-select>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="!!checkboxes" class="row mos-o-form-row">
              <div class="small-12 columns mos-u-spacer--margin-bottom-md">
                <p>
                  A Monthly Report combines valuation, performance and asset
                  allocation details of your portfolio in a structured report
                  format. To generate a Monthly Report, select the Month and
                  Year for the report to be generated as at, and select the
                  components that you require within this report. You can
                  select default components for all reports within the Reports
                  section of My Profile.
                </p>
              </div>
              <div class="small-12 columns mos-u-spacer--margin-bottom-sm">
                <atlas-button [style]="'strong'" [color]="'brand'" (click)="onGenerateReport()">
                  Generate Report
                </atlas-button>
              </div>
              <div class="small-12 columns mos-u-spacer--margin-bottom-sm">
                <a class="dsp-advanced-options" (click)="onShowCheckBoxes()">
                  <atlas-icon [haloTooltipWithArrow]="true"
                    [icon]="showCheckboxes ? 'icon-chevron-up-24' : 'icon-chevron-down-24'" [size]="'small'"
                    [haloTooltip]="'Select all components'">
                  </atlas-icon>
                  Advanced Options
                </a>
              </div>
              <div class="small-12 columns" *ngIf="showCheckboxes">
                <h4>Select Components</h4>
                <div class="row mos-u-spacer--margin-bottom-md">
                  <div class="columns">
                    <atlas-checkbox [isChecked]="allCheckbox.value" checkboxId="all-checkbox"
                      checkboxName="all-checkbox" labelTypography="typographyStyles-body-medium"
                      [disabled]="disableAll$ | async" (onChange)="onSelectAllToggle($event)">
                      <span class="dsp-reports-checkbox-label">
                        All
                        <atlas-icon *ngIf="allCheckbox.tooltip !== undefined"
                          class="mos-u-spacer--margin-left-xxsm dsp-reports-tooltip-trigger"
                          [haloTooltipWithArrow]="true" [haloTooltip]="allCheckbox.tooltip"
                          [haloTooltipPosition]="'right'" [haloTooltipShowDelay]="100" [id]="'reports-note-icon-all'"
                          [icon]="'c-info'" [collection]="'user-interface'" [size]="'small'" [alt]="'info'">
                        </atlas-icon>
                      </span>
                    </atlas-checkbox>
                  </div>
                </div>
                <div *ngFor="let checkbox of checkboxes$ | async" class="row mos-u-spacer--margin-bottom-md">
                  <div class="columns">
                    <atlas-checkbox [isChecked]="checkboxes[checkbox.key]" [checkboxId]="checkbox.key + '-checkbox'"
                      [checkboxName]="checkbox.key + '-checkbox'" labelTypography="typographyStyles-body-medium"
                      [disabled]="checkbox.disabled" (onChange)="onSelectAnyToggle($event, checkbox.key)">
                      <span class="dsp-reports-checkbox-label">
                        {{ checkbox.title }}
                        <atlas-icon *ngIf="checkbox.tooltip !== undefined"
                          class="mos-u-spacer--margin-left-xxsm dsp-reports-tooltip-trigger"
                          [haloTooltipWithArrow]="true" [haloTooltip]="checkbox.tooltip" [haloTooltipPosition]="'right'"
                          [haloTooltipShowDelay]="100" [id]="'reports-note-icon-' + checkbox.key" [icon]="'c-info'"
                          [collection]="'user-interface'" [size]="'small'" [alt]="'info'">
                        </atlas-icon>
                      </span>
                    </atlas-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dsp-reports-tabs" *ngIf="showExcel">
            <div class="row">
              <div class="columns">
                <div class="dsp-date-row dsp-content-filters-row">
                  <div class="dsp-filter ">
                    <atlas-field>
                      <atlas-field-label>From</atlas-field-label>
                      <input [(ngModel)]="from" atlasInput [min]="'1900-01-01'" [max]="todate" [Datepicker]="pickerFrom"
                        [placeholder]="'Day Month Year'" [readonly]="true" />
                      <atlas-field-suffix>
                        <datepicker-toggle [datepicker]="pickerFrom"></datepicker-toggle>
                      </atlas-field-suffix>
                      <datepicker #pickerFrom> </datepicker>
                    </atlas-field>

                  </div>
                  <div class="dsp-filter date-to month">
                    <atlas-field>
                      <atlas-field-label>To</atlas-field-label>
                      <input [(ngModel)]="to" atlasInput [min]="from" [max]="todate" [Datepicker]="pickerTo"
                        [placeholder]="'Day Month Year'" [readonly]="true" />
                      <atlas-field-suffix>
                        <datepicker-toggle [datepicker]="pickerTo"></datepicker-toggle>
                      </atlas-field-suffix>
                      <datepicker #pickerTo> </datepicker>
                    </atlas-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mos-o-form-row">
              <div class="small-12 columns mos-u-spacer--margin-bottom-md">
                <p>
                  To generate an Excel Report, select the From and To dates for the report to be generated as at,
                  and select the Excel report.
                </p>
              </div>
              <div class="excel-button">
                <div class="excel-button-row">
                  <atlas-button class="download-button" (click)="onExportCSV('investment-summary')" [style]="'no-fill'">
                    <atlas-icon [icon]="'icon-file-download-24'" [size]="'small'"></atlas-icon>
                    Investment Summary
                  </atlas-button>
                  <atlas-icon class="tooltip-icon dsp-reports-tooltip-trigger" [haloTooltipWithArrow]="true"
                    [haloTooltip]="'The report provides daily fund details for the selected time period.'"
                    [haloTooltipPosition]="'right'" [haloTooltipShowDelay]="100" [size]="'small'" [icon]="'c-info'"
                    [collection]="'user-interface'" [alt]="'info'">
                  </atlas-icon>
                </div>
                <div class="excel-button-row">
                  <atlas-button class="download-button" (click)="onExportCSV('combined-account-view')"
                    [style]="'no-fill'">
                    <atlas-icon [icon]="'icon-file-download-24'" [size]="'small'"></atlas-icon>
                    Combined Account View
                  </atlas-button>
                  <atlas-icon class="tooltip-icon dsp-reports-tooltip-trigger" [haloTooltipWithArrow]="true"
                    [haloTooltip]="'The report provides multiple account summary for the selected time period.'"
                    [haloTooltipPosition]="'right'" [haloTooltipShowDelay]="100" [size]="'small'" [icon]="'c-info'"
                    [collection]="'user-interface'" [alt]="'info'">
                  </atlas-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</dsp-content-card>